import { format } from "date-fns";
import htmlToText from "html-to-text";
import React, { Component } from "react";
import { connect } from "react-redux";
import { firebaseConnect, isEmpty } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Card, CardBody, CardHeader, Container } from "shards-react";
import { closeModal, openModal } from "../../../common/modals/modalActions";
import { objectToArray } from "../../../common/util/helper";

const mapState = (state, ownProps) => ({
  emails:
    !isEmpty(state.firebase.ordered.emails) &&
    objectToArray(state.firebase.ordered.emails),
  auth: state.firebase.auth,
  loading: state.async.loading,
  complaint: ownProps.complaint,
  complaintId: ownProps.complaintId,
  profile: state.firebase.profile,
});

const actions = {
  openModal,
  closeModal,
};

class Emails extends Component {
  openEmailModal = () => {
    this.props.openModal("EmailModal", { complaint: this.props.complaint });
  };

  openEmailDetails = (email) => {
    this.props.openModal("EmailDetails", {
      email,
      closeModal: this.props.closeModal,
    });
  };

  render() {
    const { emails, complaint, auth, profile } = this.props;
    var filteredEmails = [];

    if (profile.role === "complainant") {
      filteredEmails =
        emails &&
        emails.filter(
          (email) =>
            email.value.to === profile.email ||
            email.value.from.includes(profile.email)
        );
    } else {
      filteredEmails = emails;
    }
    return (
      <Container>
        <Card small className="my-3">
          <CardHeader className="border-bottom d-flex justify-content-between bg-primary1">
            <h5 className="m-0">Emails</h5>
            {complaint && complaint.status !== "closed" ? (
              <Button onClick={() => this.openEmailModal(complaint)}>
                Send Email
              </Button>
            ) : (
              ""
            )}
          </CardHeader>
          <CardBody className="p-0 pb-3">
            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0 ">
                    Date
                  </th>
                  <th scope="col" className="border-0">
                    Sender
                  </th>
                  <th scope="col " className="border-0">
                    Message
                  </th>
                  <th scope="col " className="border-0 text-center">
                    Details
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredEmails &&
                  filteredEmails

                    .sort(
                      (a, b) => new Date(b.value.date) - new Date(a.value.date)
                    )

                    .map((email) => (
                      <tr key={email.key}>
                        <td className="text-capitalize ">
                          {(email.value.date &&
                            format(
                              new Date(email.value.date),
                              "dd MMM yyyy HH:mm"
                            )) ||
                            ""}
                        </td>
                        <td className="text-capitalize ">
                          {email.value.sender}
                        </td>
                        <td className="text-capitalize text-wrap">
                          {htmlToText.fromString(email.value.html).slice(0, 20)}
                        </td>
                        <td className="text-center">
                          <Button
                            outline
                            onClick={() => this.openEmailDetails(email)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect((props) => [
    { path: `emails/${props.complaintId}`, storeAs: "emails" },
  ])
)(Emails);
